/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

/* ---------------------------------------------------------------------------
 * Buy 3+ progress nudge in the cart drawer and cart page.
 * Shows "Add N more items for an extra 10% off - stack code RIDEON for 10% more." above the subtotal.
 * Matches the "Buy 3 or More - Additional 10% Off" automatic discount.
 * ------------------------------------------------------------------------ */
(function () {
  var THRESHOLD = 3;
  var NUDGE_CLASS = 'buy3-nudge';
  var NUDGE_STYLE = 'margin:0 0 10px;padding:10px 12px;border-radius:8px;background:#f0e4d0;color:#090909;font-weight:600;text-align:center;line-height:1.3;';
  var lastCount = null;

  function messageFor(count) {
    if (count >= THRESHOLD) {
      return 'Nice - your extra 10% off is applied. Add code RIDEON at checkout for 10% more.';
    }
    var left = THRESHOLD - count;
    return 'Add ' + left + ' more ' + (left === 1 ? 'item' : 'items') + ' for an extra 10% off - stack code RIDEON for 10% more.';
  }

  function paint(count) {
    var anchors = document.querySelectorAll('.cart-total');
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      var parent = anchor.parentNode;
      if (!parent) {
        continue;
      }
      var el = parent.querySelector('.' + NUDGE_CLASS);
      if (!el) {
        el = document.createElement('div');
        el.className = NUDGE_CLASS;
        el.setAttribute('style', NUDGE_STYLE);
        parent.insertBefore(el, anchor);
      }
      if (!count) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
        el.textContent = messageFor(count);
      }
    }
  }

  function refresh() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          lastCount = cart.item_count;
          paint(lastCount);
        })
        .catch(function () {});
    } catch (e) {}
  }

  var pending = false;
  function scheduleRefresh() {
    if (pending) {
      return;
    }
    pending = true;
    setTimeout(function () {
      pending = false;
      refresh();
    }, 400);
  }

  function watchCartRequests() {
    try {
      if (window.fetch) {
        var nativeFetch = window.fetch;
        window.fetch = function (input) {
          var result = nativeFetch.apply(this, arguments);
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            if (url.indexOf('/cart/') !== -1) {
              result.then(scheduleRefresh, function () {});
            }
          } catch (e) {}
          return result;
        };
      }
      var nativeOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
            this.addEventListener('load', scheduleRefresh);
          }
        } catch (e) {}
        return nativeOpen.apply(this, arguments);
      };
    } catch (e) {}
  }

  function watchDom() {
    try {
      var observer = new MutationObserver(function () {
        if (lastCount === null) {
          return;
        }
        var anchors = document.querySelectorAll('.cart-total');
        for (var i = 0; i < anchors.length; i++) {
          if (anchors[i].parentNode && !anchors[i].parentNode.querySelector('.' + NUDGE_CLASS)) {
            paint(lastCount);
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  function start() {
    watchCartRequests();
    watchDom();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
